import React from "react";
import { COLORS, FONTS } from "@/constants/theme";

/**
 * Encabezado estandarizado para secciones.
 *
 * @param {{
 *   title: string,
 *   subtitle?: string,
 *   align?: "left" | "center",
 *   lineColor?: string,
 *   titleColor?: string,
 *   subtitleColor?: string,
 *   className?: string
 * }} props
 * @returns {JSX.Element}
 */
const SectionHeading = ({
  title,
  subtitle,
  align = "center",
  lineColor = COLORS.webOrange,
  titleColor = COLORS.textPrimary,
  subtitleColor = COLORS.textSecondary,
  className = "",
}) => {
  const isCentered = align === "center";

  return (
    <div className={className} style={{ textAlign: align }}>
      <h2
        className="text-[2.1rem] md:text-[3rem]"
        style={{
          color: titleColor,
          fontFamily: FONTS.display,
          lineHeight: 1.12,
          fontWeight: 600,
          letterSpacing: "-0.015em",
        }}
      >
        {title}
      </h2>
      <div
        className={isCentered ? "mx-auto mt-4" : "mt-4"}
        style={{
          width: "48px",
          borderTop: `2px solid ${lineColor}`,
        }}
      />
      {subtitle ? (
        <p
          className="mt-5 text-[1rem] md:text-[1.08rem]"
          style={{
            color: subtitleColor,
            fontFamily: FONTS.body,
            lineHeight: 1.7,
            maxWidth: isCentered ? "700px" : "62ch",
            marginInline: isCentered ? "auto" : "0",
          }}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
};

export default SectionHeading;
